import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, catchError, distinctUntilChanged, filter, finalize, first, forkJoin, from, map, mergeMap, of, skip, tap } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ProfileAboutService } from './profile-about.service';
import { Profile } from 'src/app/shared/interfaces/profile.interface';
import { ErrorHandlingService, JwtService, ProfileService } from '../index.service';
import { IAnalyze } from 'src/app/shared/interfaces/analyze.interface';
import { IOrgan } from 'src/app/shared/interfaces/organ.interface';

enum ProfileDataItems {
  NAME = 'NAME',
  STUDENT = 'STUDENT',
  EMPLOYEE = 'EMPLOYEE',
  CERTIFICATION = 'CERTIFICATION',
  SKILL = 'SKILL',
  CITY = 'CITY',
  AWARD = 'AWARD',
  LANGUAGE_SKILL = 'LANGUAGE_SKILL',
  SOFTWARE_SKILL = 'SOFTWARE_SKILL',
  VOLUNTARY_ACTIVITY = 'VOLUNTARY_ACTIVITY',
  PROJECT = 'PROJECT',
  BOOK = 'BOOK',
  YEAR_OF_BIRTH = 'YEAR_OF_BIRTH',
  NATIONAL_ID = 'NATIONAL_ID',
  GENDER = 'GENDER',
  MARITAL_STATUS = 'MARITAL_STATUS',
  MILITARY_SERVICE_STATUS = 'MILITARY_SERVICE_STATUS'
}

export type ProfileDataItemTypes = keyof typeof ProfileDataItems
export type IsHaveData = {
  profileData: boolean;
  requiredData: boolean;
  requiredQuizes: boolean;
}
export type RequiredQuizType = {
  [key:string]: {
    isCompleted: boolean;
    properties: QuizType;
  }
}
export type MyStatus = {
  analysed_username: string;
  status: string;
  updated_at: string;
}

type QuizType = {
  "name": string;
  "is_active": boolean;
  "username": string;
  "price": number;
  "management_style": string;
  "summary": string;
  "profile_photo": string;
  "banner_photo": string;
  "output_type": string;//"PERCENTAGE"|"POINT",
  "internal_note": string;
}

export type RequiredDataItem = {
  type:string, 
  name:string, 
  id:number, 
  uid:number, 
  values:{value:{value:string}}[]|string|string[]|number,
  is_required:boolean,
  structure:{
    hint?:string|null,
    max_length?:number|null,
    max_value?:number|null,
    min_answer_required?:number|null,
    min_selected_sort?:number|null,
    is_can_select_multi_option?:boolean|null,
    choices?:any|[]|string[],
    answer?:any|[]|string[],
  }
}

export enum EPD {
  NATIONAL_ID = 'national_id',
  GENDER = 'gender',
  YEAR_OF_BIRTH = 'birthday',
  MILITARY_SERVICE_STATUS = 'military_service_status',
  MARITAL_STATUS = 'marital_status',
  CITY = 'city',
}
@Injectable({
  providedIn: 'root'
})
export class CompleteFormService {
  readonly BASE_URL = environment.BASE_API_URL;
  readonly QUIZ_API_URL = environment.QUIZ_API_URL;

  private backButton:{url:string, type:string}|null = null;
  validTypes = new Set([
    'YEAR_OF_BIRTH',
    'GENDER',
    'MARITAL_STATUS',
    'MILITARY_SERVICE_STATUS',
    'NATIONAL_ID',
    'CITY'
  ])
  setBackButton(value:{url:string, type:string}|null){
    this.backButton = value
  }
  getBackButton():{url:string, type:string}|null{
    return this.backButton
  }

  errorSub:BehaviorSubject<any> = new BehaviorSubject(null);
  errorObs:Observable<any> = this.errorSub.asObservable().pipe(
    skip(1),
  );
  setError(err:any):void{
    this.errorSub.next(err)
  }
  getErrorObs():Observable<any>{
    return this.errorObs
  }  

  profileDataSub:BehaviorSubject<ProfileDataItemTypes> = new BehaviorSubject(<any>[])
  profileDataObs$:Observable<ProfileDataItemTypes> = this.profileDataSub.asObservable().pipe(
    distinctUntilChanged(),
  )
  setYearOfBirth(year:number|string){
    this.profileDataSub.next({
      ...<any>this.profileDataSub.value,
      YEAR_OF_BIRTH: year,
    })
  }
  setGender(gender:any){
    this.profileDataSub.next({
      ...<any>this.profileDataSub.value,
      GENDER: gender,
    })
  }
  setMaritalStatus(maritalStatus:any){
    this.profileDataSub.next({
      ...<any>this.profileDataSub.value,
      MARITAL_STATUS: maritalStatus,
    })
  }
  setMilitaryService(militaryServiceValue:any){
    this.profileDataSub.next({
      ...<any>this.profileDataSub.value,
      MILITARY_SERVICE_STATUS: militaryServiceValue,
    })
  }
  setCIty(data:any){
    this.profileDataSub.next({
      ...<any>this.profileDataSub.value,
      CITY: data,
    })
  }
  setNationalId(code:number|string){
    this.profileDataSub.next({
      ...<any>this.profileDataSub.value,
      NATIONAL_ID: code,
    })
  }
  getProfileDataObs():Observable<ProfileDataItemTypes>{
    return this.profileDataObs$
  }
  profileDataRequirement:any[] = []
  profilePrimaryRequirement:any[] = []
  requiredDataValuesSub:BehaviorSubject<any> = new BehaviorSubject(null)
  requiredDataValuesObs$:Observable<any> = this.requiredDataValuesSub.asObservable()
  setRequiredDataValuesSub(value:any):void{
    this.requiredDataValuesSub.next(value)
  }
  getRequiredDataValuesObs():Observable<any>{
    return this.requiredDataValuesObs$
  }

  requiredDataSub:BehaviorSubject<RequiredDataItem[]> = new BehaviorSubject(<any>[])
  requiredDataObs$:Observable<RequiredDataItem[]> = this.requiredDataSub.asObservable()
  getRequiredDataObs():Observable<RequiredDataItem[]>{
    return this.requiredDataObs$
  }
  isHaveDataSub:BehaviorSubject<IsHaveData> = new BehaviorSubject(<IsHaveData>{});
  isHaveDataObs$:Observable<IsHaveData> = this.isHaveDataSub.asObservable().pipe(
    distinctUntilChanged(),
    // skip(1),
    )
  // setIsHaveDataSub(isHaveData:IsHaveData):void{
  //   this.isHaveDataSub.next(isHaveData)
  // }
  setIsIhaveProfileDataSub(isHaveData:boolean):void{
    this.isHaveDataSub.next(<IsHaveData>{...this.isHaveDataSub.value, profileData: isHaveData})
  }
  setIsIhaveRequiredDataSub(isHaveData:boolean):void{
    this.isHaveDataSub.next(<IsHaveData>{...this.isHaveDataSub.value, requiredData: isHaveData})
  }
  setIsHaveRequiredQuizesSub(isHaveData:boolean):void{
    this.isHaveDataSub.next(<IsHaveData>{...this.isHaveDataSub.value, requiredQuizes: isHaveData})
  }
  getIsHaveDataObs():Observable<IsHaveData>{
    return this.isHaveDataObs$
  }

  requiredQuizesSub:BehaviorSubject<RequiredQuizType> = new BehaviorSubject(<any>[]);
  requiredQuizesObs$:Observable<RequiredQuizType> = this.requiredQuizesSub.asObservable().pipe(
    // skip(1),
    distinctUntilChanged(),
  )

  //status of form that is completed that or not
  myStatusSub:BehaviorSubject<MyStatus> = new BehaviorSubject(<MyStatus>{});
  myStatusObs$:Observable<MyStatus> = this.myStatusSub.asObservable().pipe(
    // skip(1),
    distinctUntilChanged(),
  )

  constructor(
    private http:HttpClient,
    private profileAboutService:ProfileAboutService,
    private profileService:ProfileService,
    private jwtService:JwtService,
    private errorHadling:ErrorHandlingService,
  ) { }


  
  isFormCompleted(id:string):Observable<any>{
    return this.jwtService.getCurrentAccountDataObs().pipe(
      filter((account:any)=>account && account.username),
      map(account=>{
        return account
      }),
      distinctUntilChanged(),
      mergeMap((account:any)=>{
        return this.http.get<any>(`${this.QUIZ_API_URL}analysis/form/submit/${id}/my_status/`).pipe(
          map((item:any)=>{
            return {...item,account:account}
          }),
          catchError(err=>{
            throw {error:err,account:account}
          })
        )
      })
    )
  }
  setMyStatusSub(status:MyStatus):void{
    this.myStatusSub.next(status);
  }
  getMyStatusObs():Observable<MyStatus>{
    return this.myStatusObs$
  }
  
  addProfileDataItem(data:any, type:'edu'|'voluntary'|'publication'|'project'|'award'|'cert'|'language'|'skill'|'work'|'software'|undefined):void{
    let prevData:any = this.profileDataSub.value
    // this.profileDataSub.next(prevData)
    switch(type){
      case 'edu':
        prevData['STUDENT'].push(data)
        break;
      case 'cert':
        prevData['CERTIFICATION'].push(data)
        break;
      case 'award':
        prevData['AWARD'].push(data)
        break;
      case 'project':
        prevData['PROJECT'].push(data)
        break;
      case 'skill':
        prevData['SKILL'].push(data)
        break;
      case 'software':
        prevData['SOFTWARE_SKILL'].push(data)
        break;
      case 'work':
        prevData['EMPLOYEE'].push(data)
        break;
      case 'voluntary':
        prevData['VOLUNTARY_ACTIVITY'].push(data)
        break;
      case 'publication':
        prevData['BOOK'].push(data)
        break;
      case 'language':
        prevData['LANGUAGE_SKILL'].push(data)
        break;
    }
  }
  allRoles:any = {}
  setAllRoles(data:any){
    this.allRoles = data
  }
  getAllRoles(){
    return this.allRoles
  }
  //get all data part of profile required data
  setAllProfileRequiredData(id: string, isCompleted: boolean = false): Observable<any> {
    let tmpProfileData: any = {};
    let tmpRolesData: any = {};
  
    return this.jwtService.getCurrentAccountDataObs().pipe(
      filter((accountData: any) => !!accountData?.username),
      mergeMap((accountData: Profile) =>
        this.getRequiredProfileData(id).pipe(
          mergeMap((dataList: any[]) => {
            if (!dataList.length) {
              this.profileDataSub.next(tmpProfileData);
              this.setAllRoles(tmpRolesData);
              return of([]);
            }
  
            this.profileDataRequirement = dataList.map(({ id, is_required, type }) => ({ id, isRequired: is_required, type }));
            this.profilePrimaryRequirement = dataList.filter(({ type }) => this.validTypes.has(type))
              .map(({ id, is_required, type }) => ({ id, isRequired: is_required, type }));
  
            const processData = (data: { type: ProfileDataItemTypes, is_required: boolean, id: string, values: any[] }, resolve?: any) => {
              tmpProfileData[data.type] = this.convertProfileDataItemInstanceToSTD(data.type, data.values);
              tmpRolesData[data.type] = this.convertProfileDataItemInstanceToSTD(data.type, data.values);
              this.setAllRoles(tmpRolesData);
              
              if (!isCompleted && resolve) {
                tmpProfileData[data.type] = this.validTypes.has(data.type)
                  ? resolve.profileAdditionalData[(<any>Object.entries(EPD).find(e => e[0] === data.type))[1]]
                  : resolve.profileExtra[data.type];
              }
              return of(null);
            };
  
            return isCompleted
              ? from(dataList).pipe(mergeMap(data => processData(data)), finalize(() => this.profileDataSub.next(tmpProfileData)))
              : this.getItems(accountData.username).pipe(
                  mergeMap((resolve: any) => from(dataList).pipe(mergeMap(data => processData(data, resolve)), finalize(() => this.profileDataSub.next(tmpProfileData))))
            );
          }),
          catchError((err)=>{throw err})
          // tap(()=>{console.log(tmpProfileData)})
        )
      )
    );
  }
  convertProfileDataItemInstanceToSTD(type: ProfileDataItemTypes, data:any){
    let output:any = []
    switch(type){
      case 'CERTIFICATION':
        if(data.length!=0){
          data.forEach((d:any, index:number) => {
            output.push({
              id: d.value.value.id,
              image:null,
              additional_data: d.value.value,
            })
          });
        }
        break;
      case 'EMPLOYEE':
        if(data.length!=0){
          data.forEach((d:any, index:number) => {
            output.push({
              id: d.value.value.id,
              image:null,
              additional_data: d.value.value,
            })
          }); 
        }
        break;
      case 'PROJECT':
        if(data.length!=0){
          data.forEach((d:any, index:number) => {
            output.push({
              id: d.value.value.id,
              image:null,
              additional_data: d.value.value,
            })
          }); 
        }
        break;
      case 'BOOK':
        if(data.length!=0){
          data.forEach((d:any, index:number) => {
            output.push({
              id: d.value.value.id,
              image:null,
              additional_data: d.value.value,
            })
          }); 
        }
        break;
      case 'STUDENT':
        if(data.length!=0){
          data.forEach((d:any, index: number) => {
            output.push({
              id: d.value.value.id,
              image: null,
              additional_data: d.value.value,
            })
          });
        }
        break;  
      case 'LANGUAGE_SKILL':
        if(data.length!=0){
          data.forEach((d:any, index:number) => {
            output.push({
              id: d.value.value.id,
              additional_data: d.value.value,
            })
          });
        }
        break;
      case 'SOFTWARE_SKILL':
        if(data.length!=0){
          data.forEach((d:any, index:number) => {
            output.push({
              id: d.value.value.id,
              additional_data: d.value.value,
            })
          });
        }
        break;
      case 'AWARD':
        if(data.length!=0){
          data.forEach((d:any, index:number) => {
            output.push({
              id: d.value.value.id,
              additional_data: d.value.value,
            })
          });
        }
        break;
      case 'SKILL':
        if(data.length!=0){
          data.forEach((d:any, index:number) => {
            output.push({
              id: d.value.value.id,
              additional_data: d.value.value,
            })
          });
        }
        break;
      case 'VOLUNTARY_ACTIVITY':
        if(data.length!=0){
          data.forEach((d:any, index:number) => {
            output.push({
              id: d.value.value.id,
              additional_data: d.value.value,
            })
          });
        }
        break;
      case 'YEAR_OF_BIRTH':
        if(data.length!=0) output = data[0].value.value
        break;
      case 'MARITAL_STATUS':
        if(data.length!=0) output = data[0].value.value
        break;
      case 'GENDER':
        if(data.length!=0) output = data[0].value.value
        break;
      case 'MILITARY_SERVICE_STATUS':
        if(data.length!=0) output = data[0].value.value
        break;
      case 'CITY':
        if(data.length!=0) output = data[0].value.value
        break;
      case 'NATIONAL_ID':
        if(data.length!=0) output = data[0].value.value
    }
    return output
  }
  isPrivate(notif:any){
    return notif.status=='PRIVATE'
  }
  isActive(notif:any){
    return notif.status=='ACTIVE'
  }
  isInActive(notif:any){
    return notif.status=='INACTIVE'
  }
  isStart(notif:any){
    return notif.is_started
  }
  isExpired(notif:any){
    return notif.is_expire
  }
  setInActiveClass(notif:any){
    if(notif?.is_started==false){return true}
    else{
      if(notif.is_expire) return true
      else return false
    }
  }
  setActiveClass(notif:any){
    if((notif.is_started==true || notif.is_started==null) && !notif.is_expire){return true}
    else{return false}
  }
  getItems(username:string):Observable<any>{
    let objObs:{profileExtra:Observable<any>, profileDetail?:Observable<any>, profileAdditionalData?:Observable<any>} = {
      profileExtra: this.profileAboutService.getAllProfileDetail(username),
    }
    if(this.profilePrimaryRequirement.length){
      if(this.profilePrimaryRequirement.find((item:any)=>item.type=='CITY')){
        objObs.profileDetail = this.profileService.getProfile(username).pipe(map((detail:any)=>{
          return detail.city
        }))
      }
      if(this.profilePrimaryRequirement.find((item:any)=>item.type!='CITY')){
        objObs.profileAdditionalData = this.profileAboutService.getUserAdditionalData(username);
      }
    }
    return forkJoin(objObs).pipe(
      map((resolve:any) => {
        if(resolve.profileDetail){
          if(!resolve.profileAdditionalData) resolve.profileAdditionalData = {city:resolve.profileDetail}
          if(resolve.profileAdditionalData) resolve.profileAdditionalData.city = resolve.profileDetail
        }
        delete resolve.profileDetail;
        return resolve
      })
    )
  }
  isHaveTheProfileRequiredData(id:string):Observable<any>{
    return this.http.get(`${this.QUIZ_API_URL}analysis/form/${id}/is_have_the_profile_required_data/`)
  }
  isHaveTheRequiredData(id:string):Observable<any>{
    return this.http.get(`${this.QUIZ_API_URL}analysis/form/${id}/is_have_the_required_data/`);
  }
  isHaveTheRequiredQuizes(id:string):Observable<any>{
    return this.http.get(`${this.QUIZ_API_URL}analysis/form/${id}/is_have_the_required_quizes/`);
  }
  isICompleteExams(exams:string[]):Observable<any>{
    return this.jwtService.getCurrentAccountDataObs().pipe(
      first(),
      filter((response:any)=>response&&response.username),
      map((account:Profile)=>account.username),
      distinctUntilChanged(),
      mergeMap((username:string)=>{
        return this.http.get(`${this.QUIZ_API_URL}multiple_criteria/result/?exam__username__in=${exams.join()}&user_username=${username}`)
      }),
      tap((i:any)=>{
        i.forEach((j:any)=>this.setRequiredQuize(j.exam.username))
      }), 
      finalize(()=>{this.setIsHaveRequiredQuizesSub((Object.values(this.requiredQuizesSub.value).findIndex(q=>!q.isCompleted)<=-1))})
    )
  }

  //get required sections
  getRequiredProfileData(id:string):Observable<any>{
    return this.http.get(`${this.QUIZ_API_URL}analysis/form/${id}/profile_required_data/`);
  }
  
  getRequiredData(id:string):Observable<any>{
    return this.http.get(`${this.QUIZ_API_URL}analysis/form/${id}/required_data/?ordering=created_at`).pipe(
      tap((i:any)=>this.requiredDataSub.next(<RequiredDataItem[]>i)),
    )
  }
  initRequiredQuizes(formId:string):Observable<RequiredQuizType>{
    return this.getRequiredQuizes(formId).pipe(
      mergeMap((requiredQuizes:any)=> this.isICompleteExams(Object.keys(requiredQuizes)))
    )
  }
  getRequiredQuizes(id:string):Observable<any>{
    return this.http.get(`${this.QUIZ_API_URL}analysis/form/${id}/required_quizes/`).pipe(
      map((i:any)=>{
        let rq:RequiredQuizType = {}
        i?.results.forEach((item:QuizType)=>{
          rq[item.username] = {
            isCompleted: false,
            properties: item
          }
        })
        this.requiredQuizesSub.next(rq)
        return rq
      }),
    )
  }
  getRequiredQuizesObs():Observable<RequiredQuizType>{
    return this.requiredQuizesObs$;
  }
  setRequiredQuize(quizUsername:string, isCompleted:boolean=true):void{
    let requiredQuizesInstance: RequiredQuizType = this.requiredQuizesSub.value
    if(requiredQuizesInstance[quizUsername] && requiredQuizesInstance[quizUsername].isCompleted == false){
      requiredQuizesInstance[quizUsername].isCompleted = isCompleted
      this.requiredQuizesSub.next(requiredQuizesInstance)
    }
  }

  //submit form sections
  initalSubmition(id:string):Observable<any>{
    return this.http.post(`${this.QUIZ_API_URL}analysis/form/${id}/initial_submission/`, {})
  }
  submitProfileRequiredData(id:string):Observable<any>{
    return this.http.post(`${this.QUIZ_API_URL}analysis/form/${id}/submit_profile_required_data/`, {}).pipe(
      tap(i=>this.isHaveDataSub.next({...this.isHaveDataSub.value, profileData: true}))
    )
  }
  submitRequiredData(id:string, f:FormData):Observable<any>{
    return this.http.post(`${this.QUIZ_API_URL}analysis/form/${id}/submit_required_data/`, f).pipe(
      tap(i=>this.isHaveDataSub.next({...this.isHaveDataSub.value, requiredData: true}))
    )
  }
  drafRequiredData(id:string, f:FormData):Observable<any>{
    return this.http.post(`${this.QUIZ_API_URL}analysis/form/${id}/draft/`, f)
  }
  drafProfileData(id:string, f:FormData):Observable<any>{
    return this.http.post(`${this.QUIZ_API_URL}analysis/form/${id}/draft_profile/`, f)
  }
  getDrafRequiredData(id:string):Observable<any>{
    return this.http.get(`${this.QUIZ_API_URL}analysis/form/${id}/draft/`)
  }
  submitExamResult(id:string):Observable<any>{
    return this.http.post(`${this.QUIZ_API_URL}analysis/form/${id}/submit_exam_result/`, {}).pipe(
      tap(i=>this.isHaveDataSub.next({...this.isHaveDataSub.value, requiredQuizes: true}))
    )
  }
  completeSubmission(id:string):Observable<any>{
    return this.http.post(`${this.QUIZ_API_URL}analysis/form/${id}/complete_submission/`, {})
  }
  filterProfileDataSelected(list:any){
    let arrList:any = []
    list.forEach((item:any)=>{
      arrList.push(item.id??item)
    })
    return arrList
  }
  submitAll(id:string):Observable<any>{
    let formData:any = new FormData()
    return of(this.getAllRoles()).pipe(
      first(),
      mergeMap((profileData:any)=>{
        console.log(profileData)
        return this.getRequiredDataValuesObs().pipe(
          first(),
          map((requiredData)=>{return {pData:profileData, rData:requiredData}}),
          catchError((err)=>{throw err}),
          mergeMap((data:any)=>{
            if(!data.pData && !data.rData){
              return this.http.post(`${this.QUIZ_API_URL}analysis/form/${id}/submit/`,{})
            }else{
              let finalData:any = {}
              if(data.pData){
                Object.entries(data.pData).forEach(
                  (item:any)=>{
                    console.log(item)
                    if(item[0]=='CITY' || item[0]=='GENDER' || item[0]=='MARITAL_STATUS' || item[0]=='MILITARY_SERVICE_STATUS' || item[0]=='YEAR_OF_BIRTH' || item[0]=='NATIONAL_ID'){
                      finalData[item[0]] = item[0]=='CITY' ? item[1]?.id ?? null : item[1]
                    }else{
                      finalData[item[0]] = this.filterProfileDataSelected(item[1])
                    }
                  }
                )
              }
              if (data.rData) {
                Object.entries(data.rData).forEach(([key, value]: any) => {
                  if (value !== null && value !== undefined) {
                    const valueType = typeof value;
              
                    if (
                      (valueType === 'string' && value !== '') ||
                      (valueType === 'number' && value !== '' && value !== null) ||
                      (valueType === 'object' && Array.isArray(value) && value.length)
                    ) {
                      finalData[key] = value;
                    }
                  }
                });
              }
              
              return this.http.post(`${this.QUIZ_API_URL}analysis/form/${id}/submit/`, finalData)
            }
          })
        )
      })
    )
  }
  getSingleFormById(form_id:string):Observable<IAnalyze>{
    return this.jwtService.getCurrentAccountDataObs().pipe(
      filter((account:any)=>account && account.username),
      map(account=>{
        return account.username
      }),
      distinctUntilChanged(),
      mergeMap((username:string)=>{
        return this.http.get<IAnalyze>(`${this.QUIZ_API_URL}analysis/form/${form_id}/`).pipe(
          catchError(err=>{throw err})
        )
      })
    )
  }
  getAnalysisData(analyzeId:string){
    return this.http.get<any>(`${this.QUIZ_API_URL}analysis/${analyzeId}/`).pipe(catchError(err=>{throw err}))
  }
  getFormStepsListStatus(form_id:string):Observable<IAnalyze>{
    return this.jwtService.getCurrentAccountDataObs().pipe(
      filter((account:any)=>account && account.username),
      map(account=>{
        return account.username
      }),
      distinctUntilChanged(),
      mergeMap((username:string)=>{
        return this.http.get<IAnalyze>(`${this.QUIZ_API_URL}analysis/form/${form_id}/extra_data/`).pipe(
          catchError(err=>{throw err})
        )
      })
    )
  }
  getEntityData(username:string): Observable<IOrgan>{
    return this.http.get<any>(`${this.BASE_URL}organ/?username=${username}`).pipe(
      catchError((err=>{throw err})),
      map(i=>i.results)
    )
  }
  

  resetData():void{
    this.setError(null)
    this.profileDataSub.next(<any>[])
    this.setRequiredDataValuesSub(null)
    this.requiredDataSub.next([])
    this.isHaveDataSub.next(<IsHaveData>{})
    this.requiredQuizesSub.next(<any>[])
    this.myStatusSub.next(<MyStatus>{})
  }
}